"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
exports.load = function () {
    $(document).ready(function () {
        ContentReady();
    });
};
function ol() {
    $('ol[type="a"]').css('list-style-type', "lower-alpha");
}
var lock_iconstr = "";
var backtotop = '<div class="Back-To-Top" id="bctop"> <div style="text-align: center;" > <img src="/msa/content/images/totop.png" /></div> <div style="color:#3e8ddd">' + CTranslate("back to top|Back to top") + '</div>  </div>';
var lockiconvlue = '<img class="lock_icon" style="height:18px; margin:0 0 2px 5px;" src="/msa/content/images/lock_icon.png" alt="" />';
function CTranslate(key) {
    try {
        return window["l"].Translator.translate(key);
    }
    catch (e) { }
    var tempvalue = key.split('|');
    if (tempvalue.length > 1) {
        return tempvalue[1];
    }
    else {
        return "#" + key;
    }
}
var translates = ["aa|Afaraf", "ab|аҧсуа бызшәа", "ae|avesta", "af|Afrikaans", "ak|Akan", "am|አማርኛ", "an|aragonés", "ar|العربية", "as|অসমীয়া", "av|авар мацӀ", "ay|aymar aru", "az|azərbaycan dili", "ba|башҡорт теле", "be|беларуская мова", "bg|български език", "bh|भोजपुरी", "bi|Bislama", "bm|bamanankan", "bn|বাংলা", "bo|བོད་ཡིག", "br|brezhoneg", "bs|bosanski jezik", "ca|català", "ce|нохчийн мотт", "ch|Chamoru", "co|corsu", "cr|ᓀᐦᐃᔭᐍᐏᐣ", "cs|čeština", "cu|ѩзыкъ словѣньскъ", "cv|чӑваш чӗлхи", "cy|Cymraeg", "da|dansk", "de|Deutsch", "dv|ދިވެހި", "dz|རྫོང་ཁ", "ee|Eʋegbe", "el|ελληνικά", "en|English", "en_AU|English (AU)", "en-AU|English (AU)", "eo|Esperanto", "es|Español (Latin America)", "es_ES|Español", "es-ES|Español", "et|eesti", "eu|euskara", "fa|فارسی", "ff|Fulfulde", "fi|suomi", "fj|vosa Vakaviti", "fo|føroyskt", "fr|français", "fr_CA|Français Canadien", "fr-CA|Français Canadien", "fy|Frysk", "ga|Gaeilge", "gd|Gàidhlig", "gl|galego", "gn|Avañe'ẽ", "gu|ગુજરાતી", "gv|Gaelg", "ha|هَوُسَ", "he|עברית", "hi|हिन्दी", "ho|Hiri Motu", "hr|hrvatski jezik", "ht|Kreyòl ayisyen", "hu|magyar", "hy|Հայերեն", "hz|Otjiherero", "ia|Interlingua", "id|Bahasa Indonesia", "ie|Interlingue", "ig|Asụsụ Igbo", "ii|ꆈꌠ꒿ Nuosuhxop", "ik|Iñupiaq", "io|Ido", "is|Íslenska", "it|italiano", "iu|ᐃᓄᒃᑎᑐᑦ", "ja|日本語", "jv|ꦧꦱꦗꦮ", "ka|ქართული", "kg|Kikongo", "ki|Gĩkũyũ", "kj|Kuanyama", "kk|қазақ тілі", "kl|kalaallisut", "km|ខ្មែរ", "kn|ಕನ್ನಡ", "ko|한국어", "kr|Kanuri", "ks|कश्मीरी", "ku|Kurdî", "kv|коми кыв", "kw|Kernewek", "ky|Кыргызча", "la|latine", "lb|Lëtzebuergesch", "lg|Luganda", "li|Limburgs", "ln|Lingála", "lo|ພາສາລາວ", "lt|lietuvių kalba", "lu|Tshiluba", "lv|latviešu valoda", "mg|fiteny malagasy", "mh|Kajin M̧ajeļ", "mi|te reo Māori", "mk|македонски јазик", "ml|മലയാളം", "mn|Монгол хэл", "mr|मराठी", "ms|bahasa Melayu", "mt|Malti", "my|ဗမာစာ", "na|Dorerin Naoero", "nb|Norsk bokmål", "nd|isiNdebele", "ne|नेपाली", "ng|Owambo", "nl|Nederlands", "nn|Norsk nynorsk", "no|Norsk", "nr|isiNdebele", "nv|Diné bizaad", "ny|chiCheŵa", "oc|occitan", "oj|ᐊᓂᔑᓈᐯᒧᐎᓐ", "om|Afaan Oromoo", "or|ଓଡ଼ିଆ", "os|ирон æвзаг", "pa|ਪੰਜਾਬੀ", "pi|पाऴि", "pl|Język Polski", "ps|پښتو", "pt|Português do Brasil", "pt_PT|português", "pt-PT|português", "pt-pt|português", "qu|Runa Simi", "rc|Kréol Rénioné", "rm|rumantsch grischun", "rn|Ikirundi", "ro|Limba Română", "ru|Русский", "rw|Ikinyarwanda", "sa|संस्कृतम्", "sc|sardu", "sd|सिन्धी", "se|Davvisámegiella", "sg|yângâ tî sängö", "si|සිංහල", "sk|Slovenčina", "sl|Slovenski", "sm|Gagana fa'a Samoa", "sn|chiShona", "so|Soomaaliga", "sq|Shqip", "sr|Srpski", "ss|SiSwati", "st|Sesotho", "su|Basa Sunda", "sv|svenska", "sw|Kiswahili", "ta|தமிழ்", "te|తెలుగు", "tg|тоҷикӣ", "th|ไทย", "ti|ትግርኛ", "tk|Türkmen", "tl|Wikang Tagalog", "tn|Setswana", "to|Faka Tonga", "tr|Türkçe", "ts|Xitsonga", "tt|татар теле", "tw|Twi", "ty|Reo Tahiti", "ug|ئۇيغۇرچە", "uk|Українська", "ur|اردو", "uz|Oʻzbek", "ve|Tshivenḓa", "vi|Tiếng Việt", "vo|Volapük", "wa|walon", "wo|Wollof", "xh|isiXhosa", "yi|ייִדיש", "yo|Yorùbá", "za|Saɯ cueŋƅ", "zh|中文繁体（台湾）", "zh_CN|中文", "zh_HK|中文繁体（香港）", "zh-CN|中文", "zh-HK|中文繁体（香港）", "zu|isiZulu", "nb-no|Norwegian", "es-es|Spanish", "zh-hk|中文繁体(香港)", "zc|中文", "zt|中文", "sh|Serbia Latin"];
function translateGroup(keys) {
    var group = new Object;
    keys.forEach(function (key) {
        var tmp = key.split("|");
        group[tmp[0]] = CTranslate(key);
    });
    return group;
}
translates = translateGroup(translates);
function geturl(type, id) {
    var url = "";
    switch (type) {
        case "KB":
            url = "/us/zh/solutions/" + id;
            break;
        case "LPDT":
            url = "/us/zh/troubleshoot/" + id;
            break;
    }
    return url;
}
function getCurrentLanguage() {
    return window["CurrentUser"].Language;
}
function FunToTop() {
    $('body,html').animate({ scrollTop: 0 }, 200);
}
;
function Getdocumentinfo(data) {
    var releaseDate = ToLocaleDateStr(new Date(data.Released.seconds * 1000));
    var strdocumentinfo = '<div>' + (data.Alias ? '<span>' + CTranslate("alias id|Alias ID") + ':' + data.Alias + '<br /></span> ' : '') + (data.FixID ? '<span>' + CTranslate("fix iD|Fix ID") + ':' + data.FixID + '<br /></span>' : "") + '<span>' + CTranslate("document id|Document ID") + '</span>: ' + data.ID + '<br /> <span>' + CTranslate("last updated|Last Updated") + '</span>: ' + releaseDate + '       </div>';
    $("#documentInfo").html(strdocumentinfo);
}
function ToLocaleDateStr(date) {
    try {
        if (!date) {
            return "";
        }
        var dt = date; //new Date(date.Unix);
        var tempdatastr = (dt.getMonth() + 1) + '/' + dt.getDate() + '/' + dt.getFullYear();
        return tempdatastr;
    }
    catch (e) { }
    return date;
}
function isCCorSP(audience) {
    if (audience === undefined || !audience || audience === null) {
        return false;
    }
    var show = false;
    for (var key in audience) {
        if (audience[key] == "CALL_CENTER" || audience[key] == "SERVICE_PROVIDER") {
            show = true;
        }
        if (audience[key] == "ANONYMOUS" || audience[key] == "CUSTOMER" || audience[key] == "B99F6570-6875-4270-9089-BB83F69529EB") {
            return false;
        }
    }
    return show;
}
function ContentReady() {
    console.log(ds_content);
    if (ds_content != undefined && ds_content != null) {
        var docid = '';
        if (ds_content.BaseContent != undefined && ds_content.BaseContent != null) {
            docid = ds_content.BaseContent.ID;
            Getdocumentinfo(ds_content.BaseContent);
            switch (ds_content.BaseContent.Type) {
                case "Manual":
                    $("#contentBody").html($($.parseHTML(ds_content.BaseContent.Body[0])).text());
                    if (ds_content.productdetail && ds_content.productdetail.length > 0 && ds_content.Url.substring(ds_content.Url.lastIndexOf("."), ds_content.Url.length).toLowerCase().indexOf("htm") > -1) {
                        var PCGBrand = "TABLET,TPG,IPG,MEDION";
                        for (var i = 0; i < ds_content.productdetail.length; i++) {
                            if (PCGBrand.indexOf(ds_content.productdetail[i].Brand) < 0) {
                                window.location.href = ds_content.Url;
                                return;
                            }
                            else {
                                var HtmURL = getQuery("HtmURL");
                                $("#UMiframeDiv").show();
                                if (HtmURL && HtmURL.toLowerCase() != "null") {
                                    $("#UMiframe").attr("src", decodeUnicode(HtmURL));
                                }
                                else {
                                    $("#UMiframe").attr("src", ds_content.Url);
                                }
                                $("#contentBody").html("");
                                break;
                            }
                        }
                    }
                    else {
                        if (ds_content.Url != "") {
                            window.location.href = ds_content.Url;
                            return;
                        }
                    }
                    break;
                case "Video":
                    $("#contentBody").html($($.parseHTML(ds_content.BaseContent.Body[0])).text());
                    var videoplayer = '';
                    if (ds_content.URL.toLowerCase().indexOf('.swf') > -1) {
                        videoplayer = '<embed width="640" height="360" align="middle" type="application/x-shockwave-flash"      wmode="transparent" allowscriptaccess="always" quality="high" allowfullscreen="true" src="' + ds_content.URL + '" />';
                    }
                    else {
                        var track = '';
                        if (!!ds_content.BaseContent.Attributes.videoext) {
                            var videoext = ds_content.BaseContent.Attributes.videoext;
                            videoext = JSON.parse(videoext);
                            if (!!videoext && !!videoext.videotrack) {
                                var videotrack = videoext.videotrack;
                                for (var key_1 in videotrack) {
                                    if (videotrack.hasOwnProperty(key_1)) {
                                        var element = videotrack[key_1];
                                        var isDefault = false;
                                        if (videotrack.hasOwnProperty(config.user.Language)) {
                                            isDefault = config.user.Language == key_1;
                                        }
                                        else if (key_1 == 'en') {
                                            isDefault = true;
                                        }
                                        track += " <track src=\"" + element.url + "\" kind=\"subtitles\"\n                                srclang=\"" + key_1 + "\" label=\"" + translates[key_1] + "\" " + (isDefault ? 'default' : '') + " />";
                                    }
                                }
                            }
                        }
                        videoplayer = "<div class=\"dow-content-videoplayer\"><video width=\"85%\"   crossorigin=\"anomymous\"  preload='auto' controls=\"controls\" autoPlay>            \n                              <source type=\"video/mp4\" src=\"" + ds_content.URL + "  \"></source>\n                              " + track + "\n                               </video> </div>";
                    }
                    $("#content_video").html(videoplayer);
                    convertSrtToVtt();
                    break;
                case "LPDT":
                    $("#contentBody").html($($.parseHTML(ds_content.BaseContent.Body[0])).text());
                    //lpdt--start
                    try {
                        if (ds_content != undefined && ds_content != null) {
                            if (ds_content.BaseContent.Type == "LPDT") {
                                var str = "";
                                if (ds_content.QuestionType == '1') {
                                    str += "<div >";
                                    if (ds_content.Response != undefined && ds_content.Response != null) {
                                        for (var key in ds_content.Response) {
                                            //
                                            str += "<input class=\"pdt_btn lpdtclickOfLPDT\" type=\"button\"  value=\"" + ds_content.Response[key].Text + "\" data-lpdtvlue=\"" + key + "\"  />";
                                        }
                                    }
                                    str += "</div>";
                                }
                                else {
                                    str += " <ul class=\"pdt_ul\" >";
                                    if (ds_content.Response != undefined && ds_content.Response != null) {
                                        for (var key in ds_content.Response) {
                                            str += " <li ><a class=\"lpdtclickOfLPDT\"  data-lpdtvlue=\"" + key + "\" href=\"javascript:void(0);\"><span>" + ds_content.Response[key].Text + "</span></a></li>";
                                        }
                                    }
                                    str += " </ul>";
                                }
                                $("#lpdtcontentdetail").html(str);
                                $("#LPDTCONTENT").show();
                                $('#btn_previousstep').on('click', function () {
                                    window.history.go(-1);
                                });
                                $('#btn_firststep').on('click', function () {
                                    var href = "";
                                    href = geturl('LPDT', GeturlQuerydetail("firstpdt"));
                                    window.location.href = href;
                                });
                                $('.lpdtclickOfLPDT').click(function () {
                                    clickOfLPDT($(this).attr("data-lpdtvlue"));
                                });
                                if (ds_content.IsRoot) {
                                    $('#btn_previousstep').hide();
                                    $('#btn_firststep').hide();
                                }
                                else {
                                    if (GeturlQuerydetail("firstpdt") != "" && GeturlQuerydetail("firstpdt") != null) {
                                        $('#btn_firststep').show();
                                    }
                                }
                            }
                            else {
                                $("#LPDTCONTENT").hide();
                            }
                        }
                    }
                    catch (e) {
                    }
                    //lpdt--end
                    break;
                default:
                    break;
            }
            if (isCCorSP(ds_content.BaseContent.Audiences)) {
                lock_iconstr = lockiconvlue;
            }
            setTitle(ds_content.BaseContent.Title);
        }
        else //solutions
         {
            docid = ds_content.ID;
            Getdocumentinfo(ds_content);
            switch (ds_content.Type) {
                case "Forum.KB":
                    var forumionc = '<p><span class="icon-forums"> </span> <span>' + CTranslate("lenovocommunityforum|The Lenovo Community Forum has provided this content.") + '</span></p>';
                    $("#content_forumionc").html(forumionc);
                    break;
                case "PS":
                    var rssurl = "";
                    if (document.location.href.toLowerCase().indexOf("?") > -1) {
                        rssurl = document.location.href + "&p=rss&source=psa";
                    }
                    else {
                        rssurl = document.location.href + "?p=rss&source=psa";
                    }
                    if (document.location.href.toLowerCase().indexOf("products") > -1) {
                        if (window["l"] != undefined) {
                            rssurl = rssurl + "&productid=" + window["l"].Common.getProductId();
                        }
                    }
                    var lock_rss = '<a href=' + rssurl + '><span className="icon-rss"></span><span>RSS</span></a>';
                    $("#c_rss").html(lock_rss);
                    break;
                default:
                    break;
            }
            // $("#contentBody").html(ds_content.Body);
            if (isCCorSP(ds_content.Audiences)) {
                lock_iconstr = lockiconvlue;
            }
            if (ds_content.Type != "MSH") {
                setTitle(ds_content.Title);
            }
            else {
                setTimeout(function () {
                    $("#contentBody iframe").each(function () {
                        var id = $(this).attr("id");
                        if (id) {
                            msh(id);
                        }
                    });
                }, 0);
                var languages = "de:de-de,ar:ar-eg,be:be-by,bg:bg-bg,bn:bn-bd,cs:cs-cz,da:da-dk,el:el-gr,en:en-us,es:es-ar,fi:fi-fi,fr:fr-fr,he:he-il,hr:hr-hr,hu:hu-hu,id:id-id,it:it-it,ja:ja-jp,ko:ko-kr,ms:ms-my,nn:nb-no,nl:nl-nl,pl:pl-pl,pt:pt-br,ro:ro-ro,ru:ru-ru,sk:sk-sk,sl:sl-si,sr:sr-latn-rs,sv:sv-se,ta:ta-in,th:th-th,tr:tr-tr,uk:uk-ua,ur:ur-pk,vi:vi-vn,zh:zh-tw";
                var arr = languages.split(',');
                var CurrentLanguage = getCurrentLanguage();
                var group = $.grep(arr, function (n, i) {
                    return n.toLowerCase().indexOf(CurrentLanguage.toLowerCase()) > -1;
                });
                var mslanguages = '';
                if (group.length > 0) {
                    mslanguages = group[0].toString().split(':')[1];
                }
                else {
                    mslanguages = 'en-us';
                }
                var pattern = /\<iframe.*?src="(.*?)".*?<\/iframe>/;
                var content = $.parseHTML($($.parseHTML(ds_content.Body[0])).text());
                var s = content[0].outerHTML.match(pattern);
                if (s) {
                    if (s.length > 1 && s[1].toLowerCase().indexOf("microsoft.com") > -1) {
                        var newUrl = s[1].toLowerCase().replace("microsoft.com", "microsoft.com/" + mslanguages);
                        ds_content.Body[0] = ds_content.Body[0].replace(s[1], newUrl);
                    }
                }
            }
            $("#contentBody").html($($.parseHTML(ds_content.Body[0])).text());
        }
        var startsWith = function (str, value) {
            var reg = new RegExp("^" + str);
            return reg.test(value);
        };
        if (startsWith('HT', docid) || startsWith('PD', docid) || startsWith('DS', docid)) {
            $("#BackToTop").html(backtotop);
            $("#bctop").on('click', function () {
                FunToTop();
            });
        }
    }
    try {
        $('a').bind("click", function () {
            var href = $(this).attr('href');
            if (href && href.substring(0, 1) === '#') {
                var subID = href.substring(1), _id = $(href), _name = $('a[name="' + subID + '"]'), targetOffset = 0, bannerHeight = 0;
                if (_id.length >= 1 || _name.length >= 1) {
                    var navfirstHeight = $('.navbar-first:eq(0)').length >= 1 ? $('.navbar-first:eq(0)').get(0).offsetHeight : 0, navsecondHeight = $('.navbar-second:eq(0)').length >= 1 ? $('.navbar-second:eq(0)').get(0).offsetHeight : 0, navmobileHeight = $('.navbar-mobile:eq(0)').length >= 1 ? $('.navbar-mobile:eq(0)').get(0).offsetHeight : 0;
                    var headerHeight = navfirstHeight + navsecondHeight + navmobileHeight;
                    var offset = $('header').length >= 1 ?
                        headerHeight :
                        $('.view_banner').length >= 1 ?
                            $('.view_banner:eq(0)').get(0).offsetHeight : 0;
                    targetOffset = (_id.offset().top - offset - 10) || (_name.offset().top - offset - 10);
                }
                if (targetOffset) {
                    window.scrollTo(0, targetOffset);
                    return false;
                }
            }
        });
    }
    catch (e) { }
    // try {
    //     if (history.length > 1) {
    //         $(".psp-content-back").show();
    //     }
    // }
    // catch (e) {
    //     $(".psp-content-back").show();
    // }
    // try{
    //     var mt = $("#divauto-tranmt").data("mt");
    //     if (mt) {
    //         window["lmd"]["machinetranslated"] = mt;
    //     }
    //     }
    //     catch(e){}
    ol();
}
function GeturlQuerydetail(name) {
    var href = window.location.href;
    var reg = new RegExp('[?&]' + name + '=([^&#]*)', 'i');
    var string = reg.exec(href);
    return string ? string[1] : null;
}
function setTitle(title) {
    var descInfo = ''; // let descInfo = l.Common.getCurrentRealm() === l.RealmType.Dcg && data.AlertDataLoss ? <span class="content-desc">{l.Translator.translate('apply this update prevent data loss|Apply this update to prevent data loss.') }</span> : null;
    var strtemp = '<div><h2>' + title + lock_iconstr + ' </h2>' + descInfo + '</div>';
    $("#dowContentName").html(strtemp);
}
function msh(elementId) {
    var mslistener = function (event) {
        if (event.type == "message" && event.origin.indexOf("microsoft") > 0) {
            var frame = $("#" + elementId); // document.getElementById(elementId);
            if (frame) {
                var host = document.createElement("a");
                host.href = frame.attr("src");
                var targetSource = "https://" + host.hostname;
                var eventOrigin = event.origin || event.originalEvent.origin;
                if (targetSource == eventOrigin && !isNaN(event.data)) {
                    frame.css({ "border": "none", "overflow": "hidden", "height": event.data + 'px' });
                    frame.attr("scrolling", "no");
                }
            }
        }
    };
    if (window.addEventListener) {
        window.addEventListener("message", mslistener, false);
    }
    else {
        getwin(true).attachEvent("onmessage", mslistener);
    }
}
function getwin(anyv) {
    var s;
    if (anyv) {
        s = window;
    }
    return s;
}
function clickOfLPDT(key) {
    try {
        var tempvaluelmdfeedback = "";
        if ($.trim(ds_content.Response[key].Text.toLowerCase()) == "yes" || $.trim(ds_content.Response[key].Text.toLowerCase()) == "はい") {
            tempvaluelmdfeedback = "Yes";
        }
        else if ($.trim(ds_content.Response[key].Text.toLowerCase()) == "no" || $.trim(ds_content.Response[key].Text.toLowerCase()) == "いいえ") {
            tempvaluelmdfeedback = "No";
        }
        if (tempvaluelmdfeedback != "") {
            window["lmd"].pdFeedback = tempvaluelmdfeedback;
            window["_satellite"].track('pdFeedback');
        }
    }
    catch (e) { }
    try {
        var event = ds_content.Response[key];
        if (event.Value == "") {
            return;
        }
        if (event.Type == 8) {
            $("#dowContentName").hide();
            $("#lpdtcontentdetail").hide();
            $("#contentBody").html(event.Value);
            $("#psp-content-detail-lpdt-button").hide();
            try {
                scroll(0, 0);
            }
            catch (e) { }
            return false;
        }
        else if (event.Type == 16) {
            if (event.Value == '')
                return false;
            window.location.href = event.Value;
        }
        else {
            var href = "";
            var pathname = window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/') + 1) + event.Value;
            if (event.Type == 4) {
                href = geturl('KB', event.Value);
            }
            else {
                href = geturl('LPDT', event.Value);
            }
            var querytemp = "";
            try {
                if (ds_content.IsRoot) {
                    if (window.location.search == "") {
                        querytemp = "?firstpdt=" + ds_content.BaseContent.ID;
                    }
                    else {
                        querytemp = "&firstpdt=" + ds_content.BaseContent.ID;
                    }
                }
            }
            catch (e) { }
            window.location.href = href + window.location.search + querytemp;
        }
    }
    catch (e) {
    }
}
function getQuery(key) {
    var query = GeturlsearchQuery(key);
    try {
        query = decodeURIComponent(decodeURI(query));
    }
    catch (e) {
    }
    try {
        query = decodeURIComponent(query);
    }
    catch (e) {
        try {
            query = decodeURI(query);
        }
        catch (e) {
        }
    }
    return query;
}
function GeturlsearchQuery(name) {
    var href = window.location.href;
    var reg = new RegExp('[?&]' + name + '=([^&#]*)', 'i');
    var string = reg.exec(href);
    return string ? string[1] : null;
}
function decodeUnicode(str) {
    str = str.replace(/\\/g, "%");
    return unescape(str);
}
